var React = require('react');
var ReactNative = require('react-native');

var {
  View,
  Animated,
  Easing
} = ReactNative;

var { Accelerometer, Gyroscope } = require('./wrappers/react-native-sensors-wrapper');

var OTHER_OBJ_PUSH_DIST = .1;
var OTHER_OBJ_PUSH_ACC = .000002;
var OTHER_OBJ_PUSH_ACC_MAX = 3*OTHER_OBJ_PUSH_ACC;
var SPIN_CO = 1000;
var MAX_NUM_COLLISSIONS = 30;
var MAX_ACC = 0.000002;
var SHOW_RED_COLLISSION = false;

function percentCollisionSameDir(start, end, startV, endV, acc, deltaT, threshold, bounded)
{
  var delta = end-start;
  if( delta == 0 ) return {isColl:false};
  if( deltaT == 0 ) return {isColl:false};

  if( (startV >= 0 && endV >= 0) || (startV <= 0 && endV <= 0) )
  {
    if( ((bounded < 0) && (start <= threshold || end <= threshold))
        || ((bounded > 0) && (start >= threshold || end >= threshold)) )
    {
      var avgV = (startV + endV)/2;
      var colT = (threshold - start)/avgV;
      var percentage = colT/deltaT;
      var newVel = startV + percentage*(endV - startV);
      var newPos = 0;
      return {isColl:true, newVel, newPos, percentage};
    }
    else
    {
      return {isColl:false}
    }
  }

  return {isColl:false}
}

function percentCollision(start, end, startV, endV, acc, deltaT, threshold, bounded)
{
  var delta = end-start;
  if( delta == 0 ) return {isColl:false};
  if( deltaT == 0 ) return {isColl:false};

  // if the V's are in the same direction, easy
  if( (startV >= 0 && endV >= 0) || (startV <= 0 && endV <= 0) )
  {
    var sameDirColl = percentCollisionSameDir(start, end, startV, endV, acc, deltaT, threshold, bounded);
    if( sameDirColl.isColl ) return sameDirColl;
  }
  else
  {
    // find when v becomes 0
    var changeDirT = Math.abs(startV/acc);

    // if collision at changeDirT, then we are done
    var changeDirPos = start + startV*changeDirT/2
    var {isColl, percentage} = percentCollisionSameDir(start, changeDirPos, startV, 0, acc, changeDirT, threshold, bounded);
    if( isColl )
    {
      var collT = percentage * changeDirT;
      return {isColl:true, percentage:Math.min(1, collT/deltaT)};
    }

    var {isColl, percentage} = percentCollisionSameDir(changeDirPos, end, 0, endV, acc, deltaT - changeDirT, threshold, bounded);
    if( isColl )
    {
      var collT = changeDirT + percentage * (deltaT - changeDirT);
      return {isColl:true, percentage:(collT/deltaT)}
    }
  }

  return {isColl:false}; // no collision
}

var PhysScene = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      objectInfos : []
    }
  },

  getInitialState : function()
  {
    return {
      time:new Animated.Value(0),
      width:-1,
      height:-1
    }
  },

  _lastTime:0,
  _acceleration:{x:0, y:0, z:0},
  componentDidMount : function()
  {
    var thisThing = this;

    this._accelerationObservable = new Accelerometer({
      updateInterval: 100, // defaults to 100ms
    });

    var thisThing = this;
    this._accelerationObservable
      .map(({ x, y, z }) =>
      {
        thisThing._acceleration = {x,y,z};
      })
    .filter(speed => speed > 20)
    .subscribe(speed => console.log(`You moved your phone with ${speed}`));;

    this.state.time.addListener(({value}) =>
    {
      var deltaT = value - thisThing._lastTime;
      deltaT = Math.min(10, deltaT);

      for( var i = 0; i < thisThing.props.objectInfos.length; i++ )
      {
        if( typeof thisThing["_ref_" + ("obj"+i)] === 'undefined' ) continue;

        var obj = thisThing["_ref_" + ("obj"+i)];
        var oldInfo = obj.getInfo();
        var isShown = oldInfo.startTime <= value;
        if( !isShown )
        {
          oldInfo.isShown = oldInfo.startTime <= value;
          obj.setInfo(oldInfo);
          continue;
        }

        var newInfo = obj.getInfoAfterDeltaT(deltaT);

        // add other obj pushes
        var numCollissions = 0;
        newInfo.collisionVectors = [];
        for( var j = 0; j < thisThing.props.objectInfos.length; j++ )
        {
          if( j == i || typeof thisThing["_ref_" + ("obj"+j)] === 'undefined' ) continue;

          var otherObj = thisThing["_ref_" + ("obj"+j)];
          if( !otherObj.isShown() ) continue;

          var otherInfo = otherObj.getInfo();

          var distX = Math.abs(otherInfo.posX - oldInfo.posX)*this.state.width;
          var distY = Math.abs(otherInfo.posY - oldInfo.posY)*this.state.height;
          var maxDist = (obj.radius() + otherObj.radius())/2;
            // console.log("distX",distX)
            // console.log("distY",distY)
            // console.log("maxDist",maxDist)
          if( distX < maxDist && distY < maxDist )
          {
            newInfo.isInCollision = true;

            var deltaX = (otherInfo.posX - oldInfo.posX)*this.state.width;
            if( deltaX == 0 ) deltaX = .00000001;
            var deltaY = (otherInfo.posY - oldInfo.posY)*this.state.height;
            if( deltaY == 0 ) deltaY = .00000001;
            newInfo.collisionVectors.push([-Math.max(-OTHER_OBJ_PUSH_ACC_MAX, Math.min(OTHER_OBJ_PUSH_ACC_MAX, OTHER_OBJ_PUSH_ACC*maxDist/(deltaX))), -Math.max(-OTHER_OBJ_PUSH_ACC_MAX, Math.min(OTHER_OBJ_PUSH_ACC_MAX, OTHER_OBJ_PUSH_ACC*maxDist/(deltaY)))]);
            // console.log("velYAvg",velYAvg)
            // newInfo.velX = (otherInfo.posX - oldInfo.posX) < 0 ? velXAvg : -velXAvg;
            // newInfo.velY = (otherInfo.posY - oldInfo.posY) < 0 ? velYAvg : -velYAvg;
            // newInfo.velX += deltaT*((distX < 0) ? OTHER_OBJ_PUSH_ACC : -OTHER_OBJ_PUSH_ACC);//Math.max(-OTHER_OBJ_PUSH_ACC_MAX,Math.min(OTHER_OBJ_PUSH_ACC_MAX, vel));
            // newInfo.velY += deltaT*((distY < 0) ? OTHER_OBJ_PUSH_ACC : -OTHER_OBJ_PUSH_ACC);//Math.max(-OTHER_OBJ_PUSH_ACC_MAX,Math.min(OTHER_OBJ_PUSH_ACC_MAX, vel));

            numCollissions++;
          }

          if( numCollissions > MAX_NUM_COLLISSIONS ) break;
        }

        var bounceDamp = 7/10;
        var bounceDampPos = 2/10;
        var timeDecel = .00000005; // needs to be related to time
        var accX = oldInfo.accX;
        var accY = oldInfo.accY;
        var {isColl, percentage} = percentCollision(oldInfo.posX, newInfo.posX, oldInfo.velX, newInfo.velX, accX, deltaT, 0, -1);
        if( isColl )
        {
          var newVelX = oldInfo.velX + percentage*(newInfo.velX - oldInfo.velX);
          newInfo.velX = Math.abs(newVelX)*bounceDamp;
          var deltaX = newInfo.posX - oldInfo.posX;
          newInfo.posX = oldInfo.posX + deltaX*percentage - deltaX*(1-percentage)*bounceDampPos;
          newInfo.angularVel = newInfo.velY*SPIN_CO;
        }

        var {isColl, percentage} = percentCollision(oldInfo.posY, newInfo.posY, oldInfo.velY, newInfo.velY, accY, deltaT, 0, -1);
        if( isColl )
        {
          var newVelY = oldInfo.velY + percentage*(newInfo.velY - oldInfo.velY);
          newInfo.velY = Math.abs(newVelY)*bounceDamp;
          var avgVelY = (newInfo.velY + oldInfo.velY)/2;
          var deltaY = avgVelY*deltaT;
          newInfo.posY = Math.max(0, oldInfo.posY - deltaY*percentage + deltaY*(1-percentage)*bounceDampPos);
          newInfo.angularVel = -newInfo.velX*SPIN_CO;
        }

        var {isColl, percentage} = percentCollision(oldInfo.posX, newInfo.posX, oldInfo.velX, newInfo.velX, accX, deltaT, 1, 1);
        if( isColl )
        {
          var newVelX = oldInfo.velX + percentage*(newInfo.velX - oldInfo.velX);
          newInfo.velX = -Math.abs(newVelX)*bounceDamp;
          var deltaX = newInfo.posX - oldInfo.posX;
          newInfo.posX = oldInfo.posX + deltaX*percentage - deltaX*(1-percentage)*bounceDampPos;
          newInfo.angularVel = -newInfo.velY*SPIN_CO;
        }

        var {isColl, percentage} = percentCollision(oldInfo.posY, newInfo.posY, oldInfo.velY, newInfo.velY, accY, deltaT, 1, 1);
        if( isColl )
        {
          var newVelY = oldInfo.velY + percentage*(newInfo.velY - oldInfo.velY);
          newInfo.velY = -Math.abs(newVelY)*bounceDamp;
          var avgVelY = (newInfo.velY + oldInfo.velY)/2;
          var deltaY = avgVelY*deltaT;
          newInfo.posY = oldInfo.posY + deltaY*percentage - deltaY*(1-percentage)*bounceDampPos;
          newInfo.angularVel = newInfo.velX*SPIN_CO;
        }
        // var decelVel = timeDecel*deltaT;
        // if( newInfo.velX < 0 ) newInfo.velX += Math.min(decelVel, Math.abs(newInfo.velX));
        // if( newInfo.velY < 0 ) newInfo.velY += Math.min(decelVel, Math.abs(newInfo.velY));
        // if( newInfo.velX > 0 ) newInfo.velX -= Math.min(decelVel, newInfo.velX);
        // if( newInfo.velY > 0 ) newInfo.velY -= Math.min(decelVel, newInfo.velY);

        // wall sticky
        // var WALL_STICK_THRESHOLD = .008;
        // if( newInfo.posX < WALL_STICK_THRESHOLD && newInfo.accX < 0 ) newInfo.posX = 0;
        // if( newInfo.posY < WALL_STICK_THRESHOLD && newInfo.accY < 0 ) newInfo.posY = 0;
        // if( newInfo.posX > (1 - WALL_STICK_THRESHOLD) && newInfo.accX > 0 ) newInfo.posX = 1;
        // if( newInfo.posY > (1 - WALL_STICK_THRESHOLD) && newInfo.accY > 0 && Math.abs(newInfo.velY) < .0001 )
        // {
        //   newInfo.velY = 0;
        //   newInfo.posY = 1;
        // }

        newInfo.accX = parseFloat(Math.max(Math.min(thisThing._acceleration.x*MAX_ACC, MAX_ACC), -MAX_ACC));
        newInfo.accY = thisThing._acceleration.y != 0 ? parseFloat(Math.max(Math.min(-thisThing._acceleration.y*MAX_ACC, MAX_ACC), -MAX_ACC)) : .000001;
        // console.log("newInfo", thisThing._acceleration.x, newInfo)
        // var THRESHOLD_STOP_VEL = .0001;
        // console.log(thisThing._acceleration);
        // if( Math.abs(newInfo.velY) < THRESHOLD_STOP_VEL ) newInfo.velY = 0;
        // if( Math.abs(newInfo.velX) < THRESHOLD_STOP_VEL ) newInfo.velX = 0;

        newInfo.isShown = true;
        obj.setInfo(newInfo);
      }
      thisThing._lastTime = value;
    });

    this.start();
  },

  componentWillUnmount : function()
  {
    this._accelerationObservable.stop();

    Animated.timing(
     this.state.time,
     {
       toValue: 0,
       duration: 0,
       easing: Easing.out,
     },
    ).start(function()
    {

    });
  },

  start : function()
  {
    var duration = 1000*30;

    Animated.timing(
     this.state.time,
     {
       toValue: duration,
       duration: duration
     },
    ).start(function()
    {

    });
  },

  render: function()
  {
    var {objects, ...otherProps} = this.props;

    var thisThing = this;

    return (
      <View {...otherProps}
        onLayout={(event)=>this.setState({width:event.nativeEvent.layout.width, height:event.nativeEvent.layout.height})}>
      {
        this.state.width > 0 && this.state.height > 0 ?
        thisThing.props.objectInfos.map(function(objectInfo, index)
        {
          return <PhysObject
            ref={(c) => { thisThing["_ref_" + ("obj"+index)] = c; }}
            key={"obj"+index}
            startPosX={objectInfo.posX}
            startPosY={objectInfo.posY}
            startVelX={objectInfo.velX}
            startVelY={objectInfo.velY}
            containerWidth={thisThing.state.width}
            containerHeight={thisThing.state.height}
            renderObject={objectInfo.renderObject}
            startTime={objectInfo.startTime}
          />
        })
        : null
      }
      </View>
    );
  }
});

var PhysObject = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      startPosX : .5,
      startPosY : .5,
      startVelX : -0.02,
      startVelY : -0.02,
      startAngle : 0,
      startAngularVel : .01,
      startTime : 0,
      containerWidth : 0,
      containerHeight : 0,
      radius : 40,
      renderObject : ()=><View style={{width:40, height:40, borderRadius:20, backgroundColor:'red'}} />
    }
  },

  getInitialState : function()
  {
    return {
      posX:this.props.startPosX,
      posY:this.props.startPosY,
      angle:this.props.startAngle,
      containerWidth:this.props.containerWidth,
      containerHeight:this.props.containerHeight,
      isShown:false,
      isInCollision:false
    }
  },

  componentDidMount : function()
  {
    this._velX = this.props.startVelX;
    this._velY = this.props.startVelY;
    this._angularVel = this.props.startAngularVel;
  },

  componentWillReceiveProps : function(newProps)
  {
    if( newProps.containerWidth !== this.state.containerWidth ) this.setState({containerWidth:newProps.containerWidth});
    if( newProps.containerHeight !== this.state.containerHeight ) this.setState({containerHeight:newProps.containerHeight});
  },

  _velX:-0.02,
  _velY:-0.02,
  _accX:0.00000,
  _accY:0.00001,
  getInfo()
  {
    return {
      velX:this._velX,
      velY:this._velY,
      accX:this._accX,
      accY:this._accY,
      posX:this.state.posX,
      posY:this.state.posY,
      angle:this.state.angle,
      startTime:this.props.startTime,
      isInCollision: false
    }
  },

  getInfoAfterDeltaT(deltaT)
  {
    var collisionVectorVelX = 0;
    var collisionVectorVelY = 0;
    if( typeof this._collisionVectors !== 'undefined' )
    {
      for( var i = 0; i < this._collisionVectors.length; i++ )
      {
        collisionVectorVelX += this._collisionVectors[i][0]*deltaT;
        collisionVectorVelY += this._collisionVectors[i][1]*deltaT;
      }
    }

    return {
      velX:this._velX + deltaT*this._accX + collisionVectorVelX,
      velY:this._velY + deltaT*this._accY + collisionVectorVelY,
      accX:this._accX,
      accY:this._accY,
      posX:this.state.posX + deltaT*(this._velX),
      posY:this.state.posY + deltaT*(this._velY),
      angularVel:this._angularVel,
      angle:this.state.angle + deltaT*this._angularVel,
      startTime:this.props.startTime,
      isInCollision: false
    }
  },

  setInfo(newInfo)
  {
    if( typeof newInfo.velX !== 'undefined' && !isNaN(newInfo.velX) ) this._velX = newInfo.velX;
    if( typeof newInfo.velY !== 'undefined' && !isNaN(newInfo.velY) ) this._velY = newInfo.velY;
    if( typeof newInfo.accX !== 'undefined' && !isNaN(newInfo.accX) ) this._accX = newInfo.accX;
    if( typeof newInfo.accY !== 'undefined' && !isNaN(newInfo.accY) ) this._accY = newInfo.accY;
    if( typeof newInfo.posX !== 'undefined' && !isNaN(newInfo.posX) ) this.setState({posX:newInfo.posX});
    if( typeof newInfo.posY !== 'undefined' && !isNaN(newInfo.posY) ) this.setState({posY:newInfo.posY});
    if( typeof newInfo.angularVel !== 'undefined' && !isNaN(newInfo.angularVel) ) this._angularVel = newInfo.angularVel;
    if( typeof newInfo.angle !== 'undefined' && !isNaN(newInfo.angle) ) this.setState({angle:newInfo.angle});
    if( typeof newInfo.isShown !== 'undefined' && !isNaN(newInfo.isShown) ) this.setState({isShown:newInfo.isShown});
    if( typeof newInfo.isInCollision !== 'undefined' && !isNaN(newInfo.isInCollision) ) this.setState({isInCollision:newInfo.isInCollision});
    if( typeof newInfo.collisionVectors !== 'undefined' ) this._collisionVectors = newInfo.collisionVectors;
  },

  isShown : function()
  {
    return this.state.isShown;
  },

  radius : function()
  {
    return this.props.radius;
  },

  render: function()
  {
    if( !this.state.isShown ) return null;
    return (
      <View style={
        {
          position:'absolute',
          left:0 + (this.state.containerWidth-(2/2)*this.props.radius)*this.state.posX,
          top:0 + (this.state.containerHeight-(2/2)*this.props.radius)*this.state.posY,
          transform: [{rotate: this.state.angle+"deg"}, {scale:this.state.isInCollision ? .95 : 1}],
          borderRadius:100000,
          backgroundColor:SHOW_RED_COLLISSION && this.state.isInCollision ? 'red' : 'transparent'
        }}>
        {this.props.renderObject()}
      </View>
    );
  }
});

module.exports = {PhysScene, PhysObject};
